// extracted by mini-css-extract-plugin
module.exports = {"list":"ContactsList_list__iVFCQ","item":"ContactsList_item__3zYTY","name":"ContactsList_name__33iwg","btn":"ContactsList_btn__2V8Tg"};